export default __webpack_public_path__ + "static/7-756bac0c4fc7d9d369bc4b33efa33741.png";